var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdcCurrentLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 16",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.05 2.051A7 7 0 0114 7.003a7.005 7.005 0 01-2.05 4.952l-1.128 1.114-2.436 2.37a1.993 1.993 0 01-2.64.117l-.132-.117-2.043-1.985-1.52-1.5a7.005 7.005 0 01-.001-9.903zm9.196.705A6 6 0 001 6.876a6.01 6.01 0 001.58 4.191l.176.183.57.567 2.982 2.905.093.08a1 1 0 001.2 0l.093-.08 2.23-2.168 1.322-1.304.176-.183a6.01 6.01 0 00-.176-8.311zM7 4.25a2.75 2.75 0 110 5.5A2.75 2.75 0 017 4.25m0 1a1.75 1.75 0 100 3.5 1.75 1.75 0 000-3.5z",
    fill: "#000"
  })));
}
export default SvgPdcCurrentLocation;